import { render, staticRenderFns } from "./waiterManager.vue?vue&type=template&id=d27135dc&scoped=true&"
import script from "./waiterManager.vue?vue&type=script&lang=js&"
export * from "./waiterManager.vue?vue&type=script&lang=js&"
import style0 from "./waiterManager.vue?vue&type=style&index=0&id=d27135dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27135dc",
  null
  
)

export default component.exports